import { StoreContext } from "contexts/StoreContext";
import React from "react";

export function useStores() {
  return React.useContext(StoreContext);
}
